// MenuContext.js
import React, { createContext, useState } from "react";

const MenuContext = createContext();

const MenuProvider = ({ children }) => {
  const [newTabItems, setNewTabItems] = useState([]);
  const [newTabContent, setNewTabContent] = useState([]);
  const [selectedTab, setSelectedTab] = useState(null);

  const filteredTab = (item) => {
    // Move the selected item to the beginning of the list
    // const itemIndex = newTabContent.findIndex((p) => p.id === item.id);
    // const selectedContent = newTabContent[itemIndex];
    // const updatedContentList = [
    //   selectedContent,
    //   ...newTabContent.slice(0, itemIndex),
    //   ...newTabContent.slice(itemIndex + 1),
    // ];
    // setNewTabContent(updatedContentList);
  };

  const setTab = (item) => {
    setSelectedTab(item);
  };

  const addToNewTab = (menuItem) => {
    const items = { val: menuItem.val, id: menuItem.id };
    if (!newTabItems.some((item) => item.id === menuItem.id)) {
      setNewTabItems([...newTabItems, items]);
      setNewTabContent([menuItem, ...newTabContent]);
    }
  };

  const removeFromNewTab = (item) => {
    setNewTabContent(newTabContent.filter((i) => i.id !== item.id));
    setNewTabItems(newTabItems.filter((i) => i.id !== item.id));
  };

  return (
    <MenuContext.Provider
      value={{
        selectedTab,
        setTab,
        newTabItems,
        setNewTabItems,
        addToNewTab,
        removeFromNewTab,
        filteredTab,
        newTabContent,
        setNewTabContent,
        // removeFormContent,
        // addToNewContent,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export { MenuContext, MenuProvider };
